'use client'

import React from 'react'

interface HeaderNavProps {
  t: (key: string) => string
  tHeader: (key: string) => string
}

/**
 * Header Navigation Component
 * Desktop navigation with MENU button and dropdown triggers
 */
export function HeaderNav({ t, tHeader }: HeaderNavProps) {
  return (
    <div className="nav-left-container">
      {/* Menu Toggle Button */}
      <button
        className="menu-toggle"
        aria-label={tHeader('ariaMainMenu')}
        data-sidebar-trigger="menu-principal"
      >
        <svg className="menu-icon-svg" width="40" height="40" viewBox="0 0 100 100">
          <path
            className="line line1"
            d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
          />
          <path className="line line2" d="M 20,50 H 80" />
          <path
            className="line line3"
            d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
          />
        </svg>
        <span className="menu-text">{t('menu')}</span>
      </button>

      {/* Desktop Nav Links */}
      <div className="nav-left">
        <div className="nav-item">
          <button className="nav-link" data-sidebar-trigger="lodges">
            <span data-short="Lodges">{tHeader('lodgeDestinations')}</span>
            <svg
              className="dropdown-arrow"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="nav-item">
          <button className="nav-link" data-sidebar-trigger="adventures">
            <span data-short="Adventures">{tHeader('guidedAdventures')}</span>
            <svg
              className="dropdown-arrow"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="nav-item">
          <button className="nav-link" data-sidebar-trigger="experiences">
            <span data-short="Experiences">{tHeader('apexExperiences')}</span>
            <svg
              className="dropdown-arrow"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
